import { ChangeDetectionStrategy, Component } from '@angular/core';
import { OfflineBannerBaseComponent } from '@ups/xplat/features';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ups-offline-banner',
  templateUrl: 'offline-banner.component.html',
  standalone: false,
})
export class OfflineBannerComponent extends OfflineBannerBaseComponent {}
